import React from "react";

const VendorIcon = ({ color = "#000000", size = "20" }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.5 15.5H7.5C6.10444 15.5 5.40665 15.5 4.83886 15.6722C3.56045 16.06 2.56004 17.0605 2.17224 18.3389C2 18.9067 2 19.6044 2 21M14.5 7.5C14.5 9.98528 12.4853 12 10 12C7.51472 12 5.5 9.98528 5.5 7.5C5.5 5.01472 7.51472 3 10 3C12.4853 3 14.5 5.01472 14.5 7.5Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <g clipPath="url(#clip0_1189_9607)">
        <path
          d="M15.9144 21.071L16.158 21.6187C16.2303 21.7817 16.3485 21.9202 16.4981 22.0174C16.6476 22.1146 16.8222 22.1664 17.0005 22.1663C17.1789 22.1664 17.3535 22.1146 17.503 22.0174C17.6526 21.9202 17.7708 21.7817 17.8431 21.6187L18.0867 21.071C18.1733 20.8766 18.3192 20.7146 18.5033 20.608C18.6887 20.5011 18.903 20.4556 19.1158 20.4779L19.7117 20.5413C19.889 20.5601 20.068 20.527 20.2269 20.4461C20.3859 20.3651 20.5179 20.2398 20.607 20.0853C20.6963 19.9309 20.7388 19.754 20.7294 19.5759C20.7201 19.3978 20.6592 19.2263 20.5543 19.0821L20.2015 18.5974C20.0759 18.4235 20.0087 18.2142 20.0098 17.9997C20.0098 17.7858 20.0775 17.5773 20.2033 17.4043L20.5561 16.9196C20.6611 16.7754 20.7219 16.6039 20.7313 16.4258C20.7406 16.2477 20.6981 16.0707 20.6089 15.9163C20.5198 15.7619 20.3877 15.6365 20.2288 15.5556C20.0699 15.4747 19.8909 15.4416 19.7135 15.4603L19.1177 15.5237C18.9049 15.5461 18.6905 15.5006 18.5052 15.3937C18.3206 15.2864 18.1748 15.1236 18.0885 14.9284L17.8431 14.3807C17.7708 14.2177 17.6526 14.0791 17.503 13.9819C17.3535 13.8847 17.1789 13.833 17.0005 13.833C16.8222 13.833 16.6476 13.8847 16.4981 13.9819C16.3485 14.0791 16.2303 14.2177 16.158 14.3807L15.9144 14.9284C15.8282 15.1236 15.6823 15.2864 15.4978 15.3937C15.3124 15.5006 15.0981 15.5461 14.8853 15.5237L14.2876 15.4603C14.1102 15.4416 13.9312 15.4747 13.7723 15.5556C13.6134 15.6365 13.4813 15.7619 13.3922 15.9163C13.303 16.0707 13.2605 16.2477 13.2698 16.4258C13.2792 16.6039 13.34 16.7754 13.445 16.9196L13.7978 17.4043C13.9236 17.5773 13.9913 17.7858 13.9913 17.9997C13.9913 18.2136 13.9236 18.422 13.7978 18.595L13.445 19.0798C13.34 19.2239 13.2792 19.3955 13.2698 19.5736C13.2605 19.7516 13.303 19.9286 13.3922 20.083C13.4814 20.2374 13.6135 20.3627 13.7724 20.4436C13.9313 20.5245 14.1102 20.5577 14.2876 20.539L14.8834 20.4756C15.0962 20.4533 15.3106 20.4988 15.4959 20.6057C15.6811 20.7126 15.8277 20.8755 15.9144 21.071Z"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M16.9998 19.2497C17.6902 19.2497 18.2498 18.69 18.2498 17.9997C18.2498 17.3093 17.6902 16.7497 16.9998 16.7497C16.3094 16.7497 15.7498 17.3093 15.7498 17.9997C15.7498 18.69 16.3094 19.2497 16.9998 19.2497Z"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_1189_9607">
          <rect
            width="10"
            height="10"
            fill="white"
            transform="translate(12 13)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default VendorIcon;
